import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    developer: {
        detail: {},
        isLoading: true
    },
    tech: {
        isTechLoading: true,
        technologies: [],
    },
    spec: {
        isLoading: true,
        specializationList: []
    },
    technologyForHeader: {
        isTechLoading: true,
        technologies: [],
    },
    specForHeader: {
        isLoading: true,
        specializationList: []
    },
    hire_registration: {
        step: 1,
        stepOneData: {
            specialization: null,
        },
        stepTwoData: {
            skills: []
        },
        stepThreeData: {

        },
    },
    selected_skill: null,
    showSuccessModal: false
};

export const commonSlice = createSlice({
    name: "common",
    initialState,
    reducers: {
        setDeveloperDetail: (state, { payload }) => {
            state.developer.detail = payload;
        },
        setDeveloperLoading: (state, { payload }) => {
            state.developer.isLoading = payload;
        },
        setTechnologies: (state, { payload }) => {
            state.tech.technologies = payload;
        },
        setTechnologyLoading: (state, { payload }) => {
            state.tech.isTechLoading = payload;
        },
        setTechnologiesForHeader: (state, { payload }) => {
            state.technologyForHeader.technologies = payload;
            state.technologyForHeader.isTechLoading = false;
        },
        setSpecializationListForHeader: (state, { payload }) => {
            state.specForHeader.specializationList = payload;
            state.specForHeader.isLoading = false;
        },
        setSpecializationList: (state, { payload }) => {
            state.spec.specializationList = payload;
        },
        setSpecializationLoading: (state, { payload }) => {
            state.spec.isLoading = payload;
        },
        hireRegistrationNextStep: (state) => {
            const { step } = state.hire_registration
            state.hire_registration.step = step + 1
        },
        hireRegistrationPrevStep: (state) => {
            const { step } = state.hire_registration
            state.hire_registration.step = step - 1
        },
        setHireRegistrationFormData: (state, { payload }) => {
            const { step } = state.hire_registration;
            const { formData } = payload;
            return {
                ...state,
                hire_registration: {
                    ...state.hire_registration,
                    ...(step === 1 && { stepOneData: { ...state.hire_registration.stepOneData, ...formData } }),
                    ...(step === 2 && { stepTwoData: { ...state.hire_registration.stepTwoData, ...formData } }),
                    ...(step === 3 && { stepThreeData: { ...state.hire_registration.stepThreeData, ...formData } }),
                }
            }
        },
        setShowSuccessModal: (state, { payload }) => {
            state.showSuccessModal = payload;
        },
        setSelectedSkill: (state, { payload }) => {
            state.selected_skill = payload;
        }
    },
});

export const {
    setTechnologies,
    setTechnologyLoading,
    setDeveloperDetail,
    setDeveloperLoading,
    setSpecializationList,
    setSpecializationLoading,
    hireRegistrationNextStep,
    hireRegistrationPrevStep,
    setHireRegistrationFormData,
    setShowSuccessModal,
    setSelectedSkill,
    setTechnologiesForHeader,
    setSpecializationListForHeader,
} = commonSlice.actions;
export default commonSlice.reducer;